import { Helmet } from "react-helmet-async";

const SITE_NAME = "Travele";
const FALLBACK_ORIGIN = "https://travele.co.id";
const DEFAULT_TITLE = "Travele — Digital Terminal Travel Door to Door & Charter Drop Off Indonesia";
const DEFAULT_IMAGE = "https://images.pexels.com/photos/36681344/pexels-photo-36681344.jpeg?auto=compress&cs=tinysrgb&w=1200&q=70";

export const Seo = ({
  title,
  description,
  path,
  image,
  type = "website",
  noindex = false,
  schema,
  prev,
  next,
  canonical: canonicalProp,
}) => {
  const origin = typeof window !== "undefined" ? window.location.origin : FALLBACK_ORIGIN;
  const pathname = path ?? (typeof window !== "undefined" ? window.location.pathname : "/");
  const canonical = canonicalProp || `${origin}${pathname}`;
  const img = image || DEFAULT_IMAGE;
  const fullTitle = title || DEFAULT_TITLE;
  const schemas = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"}
      />
      {prev && <link rel="prev" href={`${origin}${prev}`} />}
      {next && <link rel="next" href={`${origin}${next}`} />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="id_ID" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};
